jQuery(document).ready(function($) {

	// $.fn.
	// $(that).closest('.imovel').animate({
	// 	left: '250px',
	// 		opacity: '0.0'
	// }, 800, function(){
	// 	$(this).animate({
	// 		height: 0
	// 	}, 400, function(){
	// 		$(this).remove() ;
	// 	});
	// });

	$.fn.extend({
		removerElemento: function(cb) {
			return this.each(function () {
				$(this).animate({
					left: '250px',
						opacity: '0.0'
				}, 800, function(){
					$(this).animate({
						height: 0
					}, 400, function(){
						if (cb) cb();
						$(this).remove() ;
					});
				});
			});
		}

	});
	$.fn.shake = function(interval,distance,times){
	   interval = typeof interval == "undefined" ? 100 : interval;
	   distance = typeof distance == "undefined" ? 10 : distance;
	   times = typeof times == "undefined" ? 3 : times;
	   var jTarget = $(this);
	   jTarget.css('position','relative');
	   for(var iter=0;iter<(times+1);iter++){
	      jTarget.animate({ left: ((iter%2==0 ? distance : distance*-1))}, interval);
	   }
	   return jTarget.animate({ left: 0},interval);
	}
});